<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;  */
  color: #2c3e50;
  height: 100%;
  /* margin-top: 60px; */
}
html {
  height: 100%;
}
body {
  height: 100%;
  margin: 0 0;
  min-width: 1530px;
}
/* 修改 滚动条 下面 的 宽度 */
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}
/* 修改 滚动条的 下面 的 样式 */
::-webkit-scrollbar-track {
  display: none;
}
/*修改 滑块  */
::-webkit-scrollbar-thumb {
  opacity: 0.8;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue